import { render, staticRenderFns } from "./VotacaoList.vue?vue&type=template&id=10e2b852&"
import script from "./VotacaoList.vue?vue&type=script&lang=js&"
export * from "./VotacaoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports